import React from 'react'
import { MDBCol, MDBCard, MDBCardBody, MDBCardText, } from 'mdbreact'
import { GatsbyImage } from "gatsby-plugin-image"
import { CustomLink } from '../utils/helpers.js'
import { Link } from 'gatsby'

class Card extends React.Component {
  render() {
    const colHeight = this.props.height != null ? this.props.height : "auto"
    return (
      <MDBCol lg={this.props.collg} md={this.props.colmd} className="pb-card d-flex" >
        <MDBCard className="flex-fill">
          <CustomLink link={this.props.link}>
            <GatsbyImage image={this.props.image} alt={this.props.alt} className="rounded-top drop-shadow" />
          </CustomLink>
          <MDBCardBody>
            <div style={{maxHeight: colHeight, minHeight: colHeight}} > 
              <h3 className="font-alt font-w-700 letter-spacing-1 title-small title-xs-medium mt-2">
                {this.props.title}
              </h3>
              {this.props.subtitle && (
                <div className="font-w-400 text-medium text-lg-large mt-2" dangerouslySetInnerHTML={{ __html: this.props.subtitle, }} />
              )}
            </div>
            <hr />
            {this.props.link ? (
              <MDBCardText className={`font-w-400 mt-2 mb-2 ` + this.props.descriptionClass ? this.props.descriptionClass : 'text-medium'}>
                <CustomLink link={this.props.link} className="effect">
                  {this.props.description}
                </CustomLink>
              </MDBCardText>
            ) : (
              <MDBCardText className="font-w-400 text-medium mt-2 mb-2"></MDBCardText>
            )}
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    )
  }
}

export default Card